module.exports = __webpack_public_path__ + "img/60600.fb75e922.jpg";